import { getStore } from '../store/store';
export default function isQFRequestIdEqualToLatest(qfRequestId) {
    return qfRequestId === getStore().latestQFRequestId;
}
//# sourceMappingURL=isQFRequestIdEqualToLatest.js.map